module.exports = __webpack_public_path__ + "media/images/lb/660-8178e1a2faa464d585bf7cb2f82b3fe9.svg";